import "core-js/modules/es.array.push.js";
import { defineComponent } from 'vue';
import Util from '@/services/browser/Util';
import Footer from '@/components/microsites/Footer.vue';
import '@/assets/scss/microsites/legacy/Returntoadventure/main.css';
export default defineComponent({
  name: 'Microsite Returntoadventure',
  components: {
    Footer
  },
  data() {
    return {
      loading: false
    };
  },
  mounted() {
    // main js required to be loaded after the DOM was created
    let main = document.createElement('script');
    main.src = `${process.env.VUE_APP_ASSETS_URL}static/legacy/Returntoadventure/js/main.js`;
    main.defer = true;
    document.body.appendChild(main);
    setTimeout(() => {
      this.loading = false;
      const FacebookAppId = 395670150835943;
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: FacebookAppId,
          cookie: true,
          // enable cookies to allow the server to access  the session
          xfbml: true,
          // parse social plugins on this page
          version: 'v2.3' // use version 2.3
        });
      };
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
      window.dataLayer.push({
        pageType: 'Microsite',
        micrositeName: 'Returntoadventure',
        micrositePhase: '1'
      });
    }, 100);
  },
  computed: {
    dataPicture() {
      return `${process.env.VUE_APP_ASSETS_URL}static/legacy/Returntoadventure/share_fb.jpg`;
    },
    dataLink() {
      return window.location.href;
    }
  },
  methods: {
    playFree() {
      Util.playFree();
    },
    socialShare(type) {
      console.log(type);
      const uniqueURL = window.location.href;
      let title = document.title ? document.title : 'MapleStory';
      let description = document.querySelector("meta[name='description']").getAttribute('content');
      if (type === 'facebook') {
        let picture = `${process.env.VUE_APP_ASSETS_URL}static/legacy/Returntoadventure/share_fb.jpg`;
        window.FB.ui({
          method: 'feed',
          link: uniqueURL,
          name: title,
          caption: uniqueURL,
          description: description,
          picture: picture
        }, function () {});
      }
      if (type === 'twitter') {
        let twitter = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(title) + encodeURIComponent(' ') + uniqueURL;
        this.openShare(twitter);
      }
    }
  }
});